export default __webpack_public_path__ + "static/media/Icon_Artifact.28afaaf3.svg";